const showModal = (selector) => global.$(selector).modal('show');

export default showModal;
